import React from 'react';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';

const StarRating = ({ rating, reviews, showCount }) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
        stars.push(<FaStar key={`full-${i}`} color="#ffc107" size={20} />);
    }

    if (hasHalfStar) {
        stars.push(<FaStarHalfAlt key="half" color="#ffc107" size={20} />);
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
        stars.push(<FaStar key={`empty-${i}`} color="#e4e5e9" size={20} />);
    }
    const reviewCount = reviews || 0;

    if (showCount) {
        return (<div className="flex items-center">
                <div className="flex">{stars}</div>
            <span className="ml-2 text-gray-600">({reviewCount})</span>
            </div>);
    } else {
        return (<div className="flex items-center">
                <div className="flex">{stars}</div>
            </div>);
    }
};

export default StarRating;

